module.exports = __webpack_public_path__ + "img/ele-1200w.a720b1ac.jpg";